import { oc } from '@orpc/contract';
import { listTargetsInputSchema, listTargetsOutputSchema } from '../schemas/targets.schemas.js';
export const listTargetsContract = oc
    .route({
    method: 'GET',
    path: '/targets',
    tags: ['Targets'],
    summary: 'List the targets linked to at least one KPI the caller may see (search on target and KPI names)',
})
    .input(listTargetsInputSchema)
    .output(listTargetsOutputSchema);
//# sourceMappingURL=list-targets.contract.js.map